import React, { PureComponent } from 'react'
import { DsPopup, DsPopupProps } from '@am92/react-design-system'

export interface IChildPopupProps extends Omit<DsPopupProps, 'breakpoints'> {}

export default class ChildPopup extends PureComponent<IChildPopupProps> {
  render() {
    return (
      <DsPopup
        {...this.props}
        DsBottomSheetProps={{
          className: 'child-layout',
          ...this.props.DsBottomSheetProps,
          PaperProps: {
            ...this.props.DsBottomSheetProps?.PaperProps,
            sx: {
              '> .MuiPaper-root': {
                background: 'var(--ds-colour-surfaceBackground)'
              },
              ...this.props.DsBottomSheetProps?.PaperProps?.sx
            }
          },
          slotProps: {
            ...this.props.DsBottomSheetProps?.slotProps,
            backdrop: {
              sx: {
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(12px)'
              },
              ...this.props.DsBottomSheetProps?.slotProps?.backdrop
            }
          },
          CloseIconButtonProps: {
            ...this.props.DsBottomSheetProps?.CloseIconButtonProps,
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              ...this.props.DsBottomSheetProps?.CloseIconButtonProps?.sx
            }
          }
        }}
        DsDialogProps={{
          className: 'child-layout',
          ...this.props.DsDialogProps,
          PaperProps: {
            ...this.props.DsDialogProps?.PaperProps,
            sx: {
              background: 'var(--ds-colour-surfaceBackground)',
              ...this.props.DsDialogProps?.PaperProps?.sx
            }
          },
          slotProps: {
            ...this.props.DsDialogProps?.slotProps,
            backdrop: {
              sx: {
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(12px)'
              },
              ...this.props.DsDialogProps?.slotProps?.backdrop
            }
          }
        }}
      />
    )
  }
}
